import Log from "../../utils/log";
// INFO: 合约变量
// const isProd = process.env.VUE_APP_CONTRACT_ENV == "production";

// // * BSC测试网
// // HIGH: TEST Net Contract
// const DEV = {
//     ENV: "DEV",
//     AITokenAddress: "0x5aAAd6BC4F09034104180A35AcA739f7CD00Ab74",
//     InvestAIAddress: "0x525dE016f124A99ddBee83B7EF93453F73fF3457",
//     UsdtAddress: "0x32298C7ea19Dcc6454F71b811bB3503a27072766",
//     DaoAddress: "0xd2Bccb109c09065B4F5d585D1753f698a9412d26",
//     AIIEOAddress: "0xa6D016A59B72776f8817aF9a3b1413Bce7a7Fac5",
//     AIICOAddress: "0xa1bd1d76355f128aA36B0172002BFc868f2BBB7B",
//     DefaultUserAddress: "0x18D8003a3773c152CedF35B61A513AabE52F8b27",
// };

// * BSC 主网
// HIGH: Main Net Contract
const MAIN = {
    ENV: "MAIN",
    AITokenAddress: "0xf9c57fdf310ca6a5c34b15385cd8b18207ff7a74",
    InvestAIAddress: "0x7542f9A9c6172Dc3da164c6f6098bCfB71D7125B",
    UsdtAddress: "0x55d398326f99059fF775485246999027B3197955",
    DaoAddress: "0x037b202ca88d2028d82936d5615ee5088cb9fd78",
    AIIEOAddress: "0xd37e180D504848E387D4c9476c227D1Edca9Ac40",
    AIICOAddress: "0xBe701C1F6c088dB29716F3Cb1eBE6D631a90645e",
    DefaultUserAddress: "0x18D8003a3773c152CedF35B61A513AabE52F8b27",
};

// const CONFIG = isProd ? MAIN : DEV;
// const CONFIG = DEV;
const CONFIG = MAIN;

Log.log("=== ContractAddress ENV ===", CONFIG);

export default CONFIG;
